import Link from 'antd/lib/typography/Link';
import { isMobile } from 'react-device-detect';
import { Button, Col, Row } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../modules';
import Title from 'antd/lib/typography/Title';
import { useEffect } from 'react';

interface SignupStep6Props {
  redirectUrl?: string;
  isMobileApp: boolean;
  moveToGCVideo: () => void;
  moveToSCVideo: () => void;
  moveToMainPage: (enterpriseId: string) => void;
}

function SignupStep6({
  redirectUrl,
  isMobileApp,
  moveToGCVideo,
  moveToSCVideo,
  moveToMainPage,
}: SignupStep6Props) {
  const user = useSelector((state: RootState) => state.auth.auth.data);

  /**
   * 네이버 전환페이지 설정
   */
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    const script = document.createElement('script');
    script.innerHTML = `
    var _nasa={};
    if(window.wcs) _nasa["cnv"] = wcs.cnv("1","10"); // 전환유형, 전환가치 설정해야함. 설치매뉴얼 참고
   `;
    script.src = '//wcs.naver.net/wcslog.js';
    script.type = 'text/javascript';
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return (
    <>
      {user !== null && (
        <Row justify="center">
          <Col span={18}>
            <Title level={4}>
              {user.name}님! 회원가입을 완료 하였습니다.{' '}
              {isMobile
                ? isMobileApp
                  ? '로그인 해 주세요.'
                  : '모바일앱을 다운로드 해 주세요.'
                : '메인 페이지로 이동하세요.'}
            </Title>
          </Col>
        </Row>
      )}
      {!isMobileApp && isMobile && (
        <Row justify={'center'} align={'middle'} style={{ marginTop: '30px' }}>
          <Col>
            <Link
              href="https://apps.apple.com/kr/app/%ED%95%98%EC%9D%B4%EA%B3%B5%EC%82%AC/id6469765108"
              target="_blank"
            >
              <img
                src={`${process.env.PUBLIC_URL}/img/appstore-logo.png`}
                alt="appstore-logo"
                style={{ width: '150px' }}
              />
            </Link>
          </Col>
        </Row>
      )}
      {!isMobileApp && isMobile && (
        <Row justify={'center'} align={'middle'} style={{ marginTop: '10px' }}>
          <Col>
            <Link
              href="https://play.google.com/store/apps/details?id=com.higongsa.higongsa_mobile_app&pcampaignid=web_share"
              target="_blank"
            >
              <img
                src={`${process.env.PUBLIC_URL}/img/google-play-logo.png`}
                alt="google-play-logo"
                style={{ width: '150px' }}
              />
            </Link>
          </Col>
        </Row>
      )}

      {!isMobileApp && !isMobile && (
        <Row justify="center" style={{ marginTop: '50px' }}>
          {user === null ? (
            <Title level={4}>회원가입을 실패 하였습니다.</Title>
          ) : (
            <Button
              type="primary"
              size="large"
              onClick={() => moveToMainPage('' + user.myEnterprise.id)}
            >
              메인페이지로 이동
            </Button>
          )}
        </Row>
      )}

      {isMobileApp && (
        <Row justify="center" style={{ marginTop: '30px' }}>
          {user === null ? (
            <Title level={5}>회원가입을 실패 하였습니다.</Title>
          ) : (
            <Button
              type="primary"
              size="large"
              onClick={() => {
                // const accessToken = localStorage.getItem(
                //   process.env.REACT_APP_AUTH_TOKEN_NAME!,
                // );
                // console.log(accessToken);
                // // @ts-ignore
                // Print.postMessage(`${accessToken}`);
                // @ts-ignore
                Print.postMessage('');
              }}
            >
              {/* <Title level={5}>로그인 화면으로 이동</Title> */}
              로그인 화면으로 이동
            </Button>
          )}
        </Row>
      )}
    </>
  );
}

export default SignupStep6;
